export const environment = {
    production: true,
    
    //apiUrl: 'http://localhost:8080/'
    //apiUrl: 'http://52.54.138.96:8080/'
    apiUrl: 'https://desapi.workenfactor.com/'
};
